<script context="module">
	import img from './img.svelte';
	import a from './a.svelte';

	export { img, a };
</script>

<script>
	import TimeAgo from '$lib/components/TimeAgo.svelte';
	import Icon from '@iconify/svelte';

	export let metadata;
	export let context;
</script>

<svelte:head>
	<title>{metadata.title} | {context.title}</title>
	<meta name="description" content={metadata.og.description} />
	<meta property="og:title" content={metadata.og.title} />
	<meta property="og:description" content={metadata.og.description} />
	<meta property="og:url" content={context.og.url} />
	<meta property="og:type" content="website" />
	<meta property="og:image" content={context.og.image.url} />
	<meta property="og:image:alt" content={context.og.image.alt} />
	<meta property="og:image:type" content={context.og.image.type} />
	<meta property="og:image:width" content={context.og.image.width} />
	<meta property="og:image:height" content={context.og.image.height} />
	<meta name="twitter:title" content={metadata.og.title} />
	<meta name="twitter:description" content={metadata.og.description} />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:image" content={context.og.image.url} />
	<meta name="twitter:image:alt" content={context.og.image.alt} />
	<meta
		property="og:article:published_time"
		content={new Date(metadata.published_time).toISOString()}
	/>
</svelte:head>

<main class="pb-40 prose prose-lg mx-auto">
	<a href="/" class="link link-hover flex items-center gap-1 text-sm">
		<Icon icon="ic:baseline-chevron-left" width="16" height="16" />
		<span> Torna a tutti gli articoli </span>
	</a>
	<h1 class="mt-10">{metadata.title}</h1>
	<p>
		Scritto da <a href="mailto:infolast1372@gmail.com">Giovanni Princigalli</a>, pubblicato <TimeAgo
			date={new Date(metadata.published_time)}
		/>
	</p>
	<slot />
</main>
